
import {defineComponent, ref, toRefs, watch} from "vue";
import router from "@/router";
import {postLogin} from "@/utils/general";
import i18n from "@/locales";
import store from "@/store";
const vicBg = require("@/assets/image/bg-vic2.png");
const bvicBg = require("@/assets/image/bg-bvic2.png");
const tvicBg = require("@/assets/image/bg-tvic2.png");

export default defineComponent({
  name: "Login",
  props: {
    type: {
      type: Number,
    }
  },
  setup(props: any) {
    const {type} = toRefs(props);
    const vicPrefix = ref("");
    const errorText = ref('');
    const email = ref('');
    const password = ref('');
    const requestingLogin = ref(false);

    const getPrefix = (val: number) => {
      if (val === 1) {
        vicPrefix.value = "B";
      } else if (val === 2) {
        vicPrefix.value = "T";
      } else {
        vicPrefix.value = "";
      }
    }

    watch(type, (val: number) => {
      getPrefix(val);
    })
    getPrefix(type.value);

    const onLogin = (e: Event) => {
      e.preventDefault();
      if (!email.value || !password.value) {
        errorText.value = "Please input Email Address and Password";
        return;
      }
      errorText.value = '';
      requestingLogin.value = true;
      store.commit('onDataFetching', true);
      postLogin(email.value, password.value).then(() => {
        router.push({
          name: 'Member',
          params: {
            lang: i18n.global.locale
          }
        });
      }).catch((err: any) => {
        errorText.value = err.response.data.Message;

      }).finally(() => {
        requestingLogin.value = false;
        store.commit('onDataFetching', false);

      })

    }

    return {
      vicPrefix,
      vicBg,
      bvicBg,
      tvicBg,
      onLogin,
      requestingLogin,
      email,
      password,
      errorText,
    }
  }
})
